import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=28ae3cb6&scoped=true&"
import script from "./DashboardPage.vue?vue&type=script&lang=js&"
export * from "./DashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=28ae3cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae3cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ae3cb6')) {
      api.createRecord('28ae3cb6', component.options)
    } else {
      api.reload('28ae3cb6', component.options)
    }
    module.hot.accept("./DashboardPage.vue?vue&type=template&id=28ae3cb6&scoped=true&", function () {
      api.rerender('28ae3cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DashboardPage.vue"
export default component.exports